import { useEffect, useState } from 'react';
import { Icone } from '../../design/Icone';
import { lerMetaDaEquipe } from '../../vendas';
import type { MetaDaEquipe } from '../../vendas';
import { textoDaMetaDaEquipe } from './meta-da-equipe';
import './meta-da-equipe.css';

/**
 * O cartão "Meta da equipe" (Início e Meu desempenho). Sem meta da equipe no período — ou se a
 * leitura falhar —, some: não é o que ele precisa fazer agora, e nunca desenha número inventado.
 */
export function CartaoDaMetaDaEquipe() {
  const [m, setM] = useState<MetaDaEquipe | null>(null);
  useEffect(() => {
    void lerMetaDaEquipe().then((r) => r.ok && setM(r.dados.meta));
  }, []);
  if (!m) return null;
  const t = textoDaMetaDaEquipe(m);
  return (
    <section
      className={`me-equipe${m.batida ? ' me-equipe-batida' : ''}`}
      aria-label={t.titulo}
      role={m.batida ? 'status' : undefined}
    >
      <div className="me-equipe-topo">
        <span className="me-equipe-titulo">
          <Icone nome="trophy" tamanho={16} traco={1.8} /> {t.titulo}
        </span>
        <span className="me-equipe-num">{t.numeros}</span>
      </div>
      <div
        className="me-equipe-barra"
        role="progressbar"
        aria-valuenow={m.pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Equipe: ${t.numeros}`}
      >
        <div style={{ width: `${String(m.pct)}%` }} />
      </div>
      <div className="me-equipe-chamada">{t.chamada}</div>
      {t.brinde && (
        <div className="me-equipe-brinde">
          <b>{t.brinde.rotulo}:</b> {t.brinde.texto}
        </div>
      )}
    </section>
  );
}
